import { render, staticRenderFns } from "./biaoqian.vue?vue&type=template&id=184815ea&scoped=true"
import script from "./biaoqian.vue?vue&type=script&lang=js"
export * from "./biaoqian.vue?vue&type=script&lang=js"
import style0 from "./biaoqian.vue?vue&type=style&index=0&id=184815ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184815ea",
  null
  
)

export default component.exports